import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <div className="fixed bottom-0 w-full text-center">
      
      <div className="py-2">
        <span className="font-thin text-mainDark">{t("footer.credit", { year })}</span>
      </div>
    </div>
  );
}

export default Footer;